import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { Link, useNavigate } from "react-router-dom";
import "./style.scss";
import "./signup.scss";

import { KapOrgIcon2 } from "../../assets/icons";
import ProfileOption from "./components/ProfileOption";
import LanguageSwitcher from "../../../_metronic/layout/components/subheader/components/LanguageSwitcher";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { useTranslation } from "../../i18n/LanguageContext";

const PROFILE_ROUTES = {
   Organization: "/auth/national-org-registration",
   Vendors: "/auth/vendor-registration",
   Donors: "/auth/international-donor-registration",
   Expert: "/auth/expert-registration"
};

function Registration() {
   const { t } = useTranslation();
   const navigate = useNavigate();
   const [selectedProfile, setSelectedProfile] = useState(null);

   const handleSubmit = () => {
      if (PROFILE_ROUTES[selectedProfile]) {
         navigate(PROFILE_ROUTES[selectedProfile]);
      }
   };

   return (
      <div className="kap-signup">
         <div className="kap-signup__header">
            <Link to="/" className="kap-signup__back">
               <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path
                     d="M12 7H2M2 7L6.5 2.5M2 7L6.5 11.5"
                     stroke="currentColor"
                     strokeWidth="1.4"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </svg>
               {t("back-button")}
            </Link>
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
               {process.env.REACT_APP_BASE_URL === "https://stagingv2api.kaporg.com/api" && (
                  <LanguageSwitcher color="#fff" />
               )}
               <Link to="/">
                  <img src={KapOrgIcon2} alt="KAPorg" className="kap-signup__logo" />
               </Link>
            </div>
         </div>

         <div className="kap-signup__body">
            <h1 className="kap-signup__title">{t("signup-role-title")}</h1>
            <p className="kap-signup__subtitle">{t("signup-role-subtitle")}</p>

            <div className="kap-signup__options" role="radiogroup">
               <ProfileOption
                  profile="Organization"
                  selectedProfile={selectedProfile}
                  onSelect={setSelectedProfile}
                  image={toAbsoluteUrl("/media/bg/role-organization.svg")}
               />
               <ProfileOption
                  profile="Donors"
                  selectedProfile={selectedProfile}
                  onSelect={setSelectedProfile}
                  image={toAbsoluteUrl("/media/bg/role-donor.svg")}
               />
               <ProfileOption
                  profile="Expert"
                  selectedProfile={selectedProfile}
                  onSelect={setSelectedProfile}
                  image={toAbsoluteUrl("/media/bg/role-expert.svg")}
               />
            </div>

            <button
               type="button"
               onClick={handleSubmit}
               disabled={!selectedProfile}
               className="kap-signup__continue"
            >
               {t("continue-button")}
               <svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path
                     d="M2 7H12M12 7L7.5 2.5M12 7L7.5 11.5"
                     stroke="currentColor"
                     strokeWidth="1.4"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </svg>
            </button>
         </div>
      </div>
   );
}

export default injectIntl(Registration);
